// ###########################################
// # variaveis de configuração do sistema    #
// ###########################################

var globals = {
  REACT_APP_CATALOGO: process.env.REACT_APP_CATALOGO,
  REACT_APP_APIBASE: process.env.REACT_APP_APIBASE,
  REACT_APP_ENDERECO: process.env.REACT_APP_ENDERECO,
};
export default globals;
 